import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    cardHeader: {
      marginBottom: spacing(5),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    divider: {
      backgroundColor: colors.grey.light,
      height: 1,
      width: '100%',
      margin: spacing(4, 0),
    },
    rowContainer: {
      display: 'flex',
      gap: spacing(1),
      alignItems: 'start',
      justifyContent: 'start',
      flexDirection: 'column',
      marginBottom: spacing(4),
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    fieldContainer: {
      width: '100%',
    },
    subLabel: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '18px',
      marginBottom: spacing(2),
    },
    subLabelError: {
      color: colors.red.darkest,
    },
    entirePropertySection: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: spacing(5),
    },
    floorUnitsLabel: {
      fontSize: 14,
      fontWeight: 500,
      color: colours.neutral[900],
      marginBottom: spacing(2),
      marginTop: spacing(4),
    },
    formFooter: {
      display: 'flex',
      wrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    addFloorUnitButton: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(1),
      alignSelf: 'flex-start',
      cursor: 'pointer',
      fontSize: 14,
      fontWeight: 500,
      color: colors.kato.neutral[900],

      '&:hover': {
        color: colors.blue.darkish,
      },
    },
    totalSpace: {
      display: 'flex',
      gap: spacing(4),
      flex: '1 0 auto',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    label: {
      color: colours.neutral[900],
      fontWeight: 500,
      fontSize: 14,
    },
    buildingTypesRow: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      width: '100%',
    },
    metricSelect: {
      width: 120,
    },
    totalSizeField: {
      width: 120,
    },
    addressContainer: {
      display: 'flex',
      gap: spacing(2),
      alignItems: 'center',
      width: '100%',
    },
    addressField: {
      flex: 1,
      '& .MuiInputBase-root': {
        border: `1px solid ${colours.neutral[300]}`,
        borderRadius: 4,
      },
    },
    editButton: {
      flexShrink: 0,
    },
    entirePropertyRadioGroup: {
      marginTop: spacing(3),
    },
  });
